import React, { Component } from 'react';
import { Redirect } from 'react-router'
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import Snackbar from "components/Snackbar/Snackbar";
import Icon from "../components/Selfcare/Common/Icon";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import setNewPasswordPageStyle from "assets/jss/material-dashboard-pro-react/views/setNewPasswordPageStyle";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangePassword", this, {
            headers: { Authorization: "Bearer " + auth.getAccessToken(), ServerToken: window.sessionStorage.ServerToken },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            snackbarOpen: false,
            snackbarMessage: '',
            oldPassword: '',
            password: '',
            passwordRepeat: '',
        };
        this.oldPasswordInput = React.createRef();
        this.passwordInput = React.createRef();
        this.passwordRepeatInput = React.createRef();
        this.emailInput = React.createRef();
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.SelfcareDisabled && !this.state.SelfcareDisabled) {
            auth.signOut();
        }
        if (!this.state.UnAuthorized && nextState.UnAuthorized) {
            auth.signOut();
        }
        if (!this.state.AlertPasswordChanged && nextState.AlertPasswordChanged) {
            if (this.hasLocalStorage() && localStorage.chRememberMe) {
                localStorage.chPassword = nextState.EncryptedPassword;
            }
            MySwal.fire({
                title: this.props.t('selfcare:notification.passwordischanged'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (!this.state.AlertPasswordChangeFailed && nextState.AlertPasswordChangeFailed) {
            setTimeout(
                function () {
                    this.setState({ AlertPasswordChangeFailed: false });
                    this.setState({ snackbarOpen: true, snackbarMessage: this.props.t('selfcare:notification.passwordchangefailed') });
                    this.dispatchState({ AlertPasswordChangeFailed: false });
                }.bind(this),
                100
            );
        }
    }
    componentDidUpdate() {
        if (this.state.PasswordErrorText === undefined) {
            return;
        }
        if (this.state.OldPasswordErrorText !== '') {
            this.oldPasswordInput.current.focus();
        }
        if (this.state.PasswordErrorText !== '') {
            this.passwordInput.current.focus();
        }
        if (this.state.PasswordRepeatErrorText !== '') {
            this.passwordRepeatInput.current.focus();
        }
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }

    hasLocalStorage = function () {
        try {
            window.localStorage.setItem("__test", "data");
            window.localStorage.removeItem("__test");
        } catch (e) {
            return false;
        }
        return true;
    }

    handleChange = name => event => {
        this.dispatchState({ [name]: event.target.checked, ClearErrors: true });
    };

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }

    render() {
        console.debug('ChangePassword render');

        const { classes } = this.props;
        const { t } = this.props;
        let { oldPassword, password, passwordRepeat, show } = this.state;
        const hideSnackbar = _ => {
            this.setState({ snackbarOpen: false });
        }
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                    <Snackbar open={this.state.snackbarOpen} color="rose" message={this.state.snackbarMessage} place="bc" close={true} closeNotification={hideSnackbar}/>
                        <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                            <GridContainer justify="center">
                            <GridItem xs={12} sm={10} md={8} lg={6} xl={4}>
                                    <Icon name="lock" size={48} color="#FFFFFF" />
                                    <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                        {t('selfcare:item.changepassword')}
                                    </div>
                                <div style={{ fontSize: '12px', paddingTop: '20px' }}>{t('selfcare:info.passwordrequirements')}
                                </div>
                                </GridItem>
                            </GridContainer>
                        </div>
                        <div style={{ padding: '20px' }}>
                        <form onSubmit={(e) => { e.preventDefault(); this.dispatchState({ ClearErrors: true }); this.dispatchState({ PerformChange: { oldPassword: oldPassword, password: password, passwordRepeat: passwordRepeat } }); }}>
                                <GridContainer direction="row" justify="center" alignItems="center">
                                <GridItem xs={12} sm={10} md={8} lg={6} xl={4}>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>
                                                <FormControl fullWidth error={this.state.OldPasswordErrorText !== ''} className={classes.margin}>
                                                    <InputLabel
                                                        classes={{
                                                            root: classes.cssLabel,
                                                            focused: classes.cssFocused
                                                        }}
                                                        htmlFor="oldpassword"
                                                    >
                                                    {t('selfcare:label.oldpassword')}
                                            </InputLabel>
                                                    <Input
                                                        classes={{
                                                            underline: classes.cssUnderline
                                                        }}
                                                        id="oldpassword"
                                                        onChange={event => {
                                                            this.setState({ oldPassword: event.target.value, PasswordErrorText: '', PasswordRepeatErrorText: '', OldPasswordErrorText: '' });
                                                        }}
                                                        type="password"
                                                        value={oldPassword}
                                                        color="secondary"
                                                        autoFocus
                                                        inputRef={this.oldPasswordInput}
                                                    />
                                                    <FormHelperText id="password-error-text">{this.state.OldPasswordErrorText}</FormHelperText>
                                                </FormControl>
                                                <FormControl fullWidth error={this.state.PasswordErrorText !== ''} className={classes.margin}>
                                                    <InputLabel
                                                        classes={{
                                                            root: classes.cssLabel,
                                                            focused: classes.cssFocused
                                                        }}
                                                        htmlFor="password"
                                                    >
                                                    {t('selfcare:label.newpassword')}
                                            </InputLabel>
                                                    <Input
                                                        classes={{
                                                            underline: classes.cssUnderline,
                                                        }}
                                                        id="password"
                                                        onChange={event => {
                                                            this.setState({ password: event.target.value, PasswordErrorText: '', PasswordRepeatErrorText: '', OldPasswordErrorText: '' });
                                                        }}
                                                        type="password"
                                                        value={password}
                                                        color="secondary"
                                                        inputRef={this.passwordInput}
                                                    />
                                                    <FormHelperText id="password-error-text">{this.state.PasswordErrorText}</FormHelperText>
                                                </FormControl>
                                                <FormControl fullWidth error={this.state.PasswordRepeatErrorText !== ''} className={classes.margin}>
                                                    <InputLabel
                                                        classes={{
                                                            root: classes.cssLabel,
                                                            focused: classes.cssFocused
                                                        }}
                                                        htmlFor="password-repeat"
                                                    >
                                                    {t('selfcare:label.confirmpassword')}
                                            </InputLabel>
                                                    <Input
                                                        classes={{
                                                            underline: classes.cssUnderline
                                                        }}
                                                        id="password-repeat"
                                                        onChange={event => {
                                                            this.setState({ passwordRepeat: event.target.value, PasswordErrorText: '', PasswordRepeatErrorText: '', OldPasswordErrorText: '' });
                                                            
                                                        }}
                                                        type="password"
                                                        value={passwordRepeat}
                                                        color="secondary"
                                                        inputRef={this.passwordRepeatInput}
                                                    />
                                                    <FormHelperText id="password-repeat-error-text">{this.state.PasswordRepeatErrorText}</FormHelperText>
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <div style={{ paddingTop: '20px' }}>
                                        <Button size="sm" type="submit" variant="contained" color="rose">{t('selfcare:button.changepassword')}</Button>
                                        <ButtonX size="small" id='cancel' onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </form>
                        </div>
            </div>
        );
    }
}
ChangePassword.propTypes = {
};

export default compose(
    withStyles(setNewPasswordPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, ChangePassword));